export const USE_CURRENT_USER_INPUT_ID = 'use_current_user_as_source'
